
import apiClient from "../helpers/apiClient";

const API_RESTO_HOST = `/api/v2/user-resto`
const api = apiClient();

export const getRestoHosts = (restoId) =>
  restoId ? api.get(`${API_RESTO_HOST}/hosts/${restoId}`) : api.get(`${API_RESTO_HOST}/hosts`);
export const getHostRestoById = (id) => api.get(`${API_RESTO_HOST}/hosts/${id}`);
export const getHostRestoDetailsById = (id) => api.get(`${API_RESTO_HOST}/hosts/details/${id}`);
export const getCeoResto = () => api.get(`${API_RESTO_HOST}/ceo/restos`);
export const getCeoRestoHosts = () => api.get(`${API_RESTO_HOST}/ceo/hosts`);
